import "stylesheets/devise";
import { Application } from "@hotwired/stimulus"
import PolicyAcceptanceController from "../controllers/policy_acceptance_controller"
import "bootstrap"
import "@fortawesome/fontawesome-free/css/all"

import "flash_messages"
import "google_analytics"
import "components/devise"

import Rails from '@rails/ujs'
Rails.start()
window.Rails = Rails

const stimulusApp = Application.start()
stimulusApp.register("policy-acceptance", PolicyAcceptanceController)

require('select2')

document.addEventListener("DOMContentLoaded", function() {
  $('.select2').select2({ width: '100%' })
});
